import React from "react";
import styles from "./Projects.module.css";
import Carousel from "react-elastic-carousel";
import Fade from "react-reveal/Fade";
import Typewriter from "typewriter-effect";
import socialsaver from "../../Assets/Projects/socialsaver.png";
import instaclone from "../../Assets/Projects/instaclone.png";
import covidinfo from "../../Assets/Projects/covidliveinfo.png";

import GitHubIcon from "@mui/icons-material/GitHub";
import LaunchIcon from "@mui/icons-material/Launch";

const Projects = () => {
  const breakpoints = [
    { width: 1, itemsToShow: 1 },
    { width: 500, itemsToShow: 2 },
    { width: 768, itemsToShow: 2 },
    { width: 1200, itemsToShow: 2 },
  ];

  return (
    <div className={styles.projectsMainDiv}>
      <h1 style={{ padding: "0 10% 0 10%" }}>
        <Typewriter
          style={{ fontWeight: "bold" }}
          options={{
            autoStart: true,
            loop: true,
            delay: 40,
            strings: ["Projects()"],
          }}
        />
      </h1>
      <div>
        <div className={styles.projectsDiv}>
          <Carousel breakPoints={breakpoints}>
            <Fade top duration={2000}>
              <div className={styles.carouselCard}>
                <h5>
                  <i>{"<Android App/>"}</i>
                </h5>
                <img alt="poster" src={socialsaver} />
                <h3>Social Saver : All in one Downloader</h3>
                <p>
                  This is a Social Media saver app which is used to download
                  files from different social media platforms which is available
                  now on Playstore with 5.0 ratings and 100+ user downloads
                </p>
                <div className={styles.techstack}>
                  <div className={styles.techstackItem}>Flutter</div>
                  <div className={styles.techstackItem}>Dart</div>
                  <div className={styles.techstackItem}>Android</div>
                  <div className={styles.techstackItem}>Kotlin</div>
                  <div className={styles.techstackItem}>Web scrapping</div>
                </div>
                <div style={{ marginTop: "20px" }} className={styles.techstack}>
                  <a
                    title="Go to playstore app"
                    style={{ zIndex: "1000", position: "relative" }}
                    href="https://play.google.com/store/apps/details?id=com.sayproductions.socialsaver"
                    target="_blank"
                    rel="noreferrer"
                    onClick={(e) => {
                      window.open(e.currentTarget.href);
                    }}
                  >
                    <LaunchIcon className={styles.linkBtn} />
                  </a>
                </div>
              </div>
            </Fade>
            <Fade top duration={2000}>
              <div className={styles.carouselCard}>
                <h5>
                  <i>{"<Android App/>"}</i>
                </h5>
                <img alt="poster" src={covidinfo} />
                <h3>Covid-19 LiveInfo App</h3>
                <p>
                  This app was made when the Covid-19 break out started. This
                  app shows the live Covid stats using an Api. This app also
                  provides many other important different functionalities which
                  were important for the user.
                </p>
                <div className={styles.techstack}>
                  <div className={styles.techstackItem}>Android</div>
                  <div className={styles.techstackItem}>JAVA</div>
                  <div className={styles.techstackItem}>RestAPI</div>
                </div>
                <div style={{ marginTop: "20px" }} className={styles.techstack}>
                  <a
                    title="Go to this app's Github repo"
                    style={{ zIndex: "1000", position: "relative" }}
                    href="https://github.com/Aniketyadav44/COVID_19LiveInfo"
                    target="_blank"
                    rel="noreferrer"
                    onClick={(e) => {
                      window.open(e.currentTarget.href);
                    }}
                  >
                    <GitHubIcon className={styles.linkBtn} />
                  </a>
                  <a
                    title="Get apk of this app"
                    style={{ zIndex: "1000", position: "relative" }}
                    href="https://drive.google.com/file/d/1t6NKGhWmy4UQi5LHYavplLLV_XeV9RjD/view?usp=sharing"
                    target="_blank"
                    rel="noreferrer"
                    onClick={(e) => {
                      window.open(e.currentTarget.href);
                    }}
                  >
                    <LaunchIcon className={styles.linkBtn} />
                  </a>
                </div>
              </div>
            </Fade>

            <Fade top duration={2000}>
              <div className={styles.carouselCard}>
                <h5>
                  <i>{"<Full Stack Web Project/>"}</i>
                </h5>
                <img alt="poster" src={instaclone} />
                <h3>Instagram Clone</h3>
                <p>
                  This website is an exact clone of Instagram website where we
                  can signin, signup, see other’s post & profiles, like,
                  comment, follow and unfollow other users, search other users,
                  reset and change password.
                </p>
                <div className={styles.techstack}>
                  <div className={styles.techstackItem}>HTML</div>
                  <div className={styles.techstackItem}>CSS Modules</div>
                  <div className={styles.techstackItem}>Javascript</div>
                  <div className={styles.techstackItem}>ReactJS</div>
                  <div className={styles.techstackItem}>ExpressJS</div>
                  <div className={styles.techstackItem}>NodeJS</div>
                  <div className={styles.techstackItem}>MongoDB</div>
                  <div className={styles.techstackItem}>Cloudinary</div>
                  <div className={styles.techstackItem}>Material-UI</div>
                </div>
                <div style={{ marginTop: "20px" }} className={styles.techstack}>
                  <a
                    title="Go to website"
                    style={{ zIndex: "1000", position: "relative" }}
                    href="https://instagram-clone4848.herokuapp.com/"
                    target="_blank"
                    rel="noreferrer"
                    onClick={(e) => {
                      window.open(e.currentTarget.href);
                    }}
                  >
                    <LaunchIcon className={styles.linkBtn} />
                  </a>
                </div>
              </div>
            </Fade>
          </Carousel>
        </div>
      </div>
    </div>
  );
};

export default Projects;
